import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import clsx from 'clsx';
import { PostListFilterByEnum, PostListFilterByOperator, } from '@tribeplatform/gql-client/types';
import { dayjs } from '@tribeplatform/react-components/common';
import { SpaceImage } from '@tribeplatform/react-components/Space';
import { usePosts } from '@tribeplatform/react-sdk/hooks';
import { simplifyPaginatedResult } from '@tribeplatform/react-sdk/utils';
import { Media } from '@tribeplatform/react-ui-kit/Media';
import { Multiselect } from '@tribeplatform/react-ui-kit/Multiselect';
import { SearchableSelect } from '@tribeplatform/react-ui-kit/SearchableSelect';
import { useDebounce } from '../common/hooks/useDebounce';
import { pickIfExists } from './arrays.utils';
const isMultiple = (props) => props.multiple === true;
export const PostPicker = (props) => {
    const { placeholder, spaceIds, postTypeIds, options } = props;
    const [search, setSearch] = useState('');
    const debouncedQuery = useDebounce(search, 300);
    let filterBy;
    if (debouncedQuery) {
        filterBy = [
            {
                keyString: 'fields.title',
                // key is not used when keyString is present
                key: PostListFilterByEnum.boolean1,
                operator: PostListFilterByOperator.contains,
                value: JSON.stringify(debouncedQuery),
            },
        ];
    }
    const { data, isLoading } = usePosts({
        fields: {
            createdBy: {
                member: 'basic',
            },
            space: {
                image: 'basic',
            },
        },
        variables: {
            filterBy,
            limit: 20,
            spaceIds,
            postTypeIds,
        },
        useInfiniteQueryOptions: {
            enabled: !options,
        },
    });
    const posts = useMemo(() => { var _a; return options || ((_a = simplifyPaginatedResult(data)) === null || _a === void 0 ? void 0 : _a.nodes) || []; }, [data, options]);
    if (isMultiple(props)) {
        const { value, onChange } = props;
        const suggestedPosts = pickIfExists(posts, value, 'id');
        return (_jsxs(Multiselect, { value: value || [], options: suggestedPosts, onChange: onChange, searchable: true, onInputChange: setSearch, children: [_jsx(Multiselect.Button, { placeholder: placeholder, children: value === null || value === void 0 ? void 0 : value.map((post, index) => (_jsx(Multiselect.SelectedItem, { className: "px-1 pe-2", value: post, index: index, children: _jsx("div", { className: "flex items-center post-x-2", children: _jsx("span", { className: "truncate", children: post === null || post === void 0 ? void 0 : post.title }, void 0) }, void 0) }, post.id))) }, void 0), _jsxs(Multiselect.Items, { children: [suggestedPosts.map((post, index) => (_jsx(Multiselect.Item, { value: post, index: index, children: ({ active }) => _jsx(Item, { post: post, active: active }, void 0) }, post.id))), isLoading && (_jsx(Multiselect.ItemsEmpty, { children: "Loading..." }, void 0)), !isLoading && search && suggestedPosts.length === 0 && (_jsx(Multiselect.ItemsEmpty, { children: "No results" }, void 0))] }, void 0)] }, void 0));
    }
    const { value, onChange } = props;
    const suggestedPosts = value
        ? pickIfExists(posts, [value], 'id')
        : posts;
    return (_jsxs(SearchableSelect, { value: value, options: suggestedPosts, onChange: onChange, onInputChange: setSearch, children: [_jsx(SearchableSelect.Button, { placeholder: placeholder, children: value && (_jsx("div", { className: "flex items-center post-x-2", children: _jsx("span", { className: "truncate", children: value === null || value === void 0 ? void 0 : value.title }, void 0) }, void 0)) }, void 0), _jsxs(SearchableSelect.Items, { children: [suggestedPosts.map(post => (_jsx(SearchableSelect.Item, { value: post.id, children: ({ active }) => _jsx(Item, { post: post, active: active }, void 0) }, post.id))), isLoading && (_jsx(SearchableSelect.ItemsEmpty, { children: "Loading..." }, void 0)), !isLoading && search && suggestedPosts.length === 0 && (_jsx(SearchableSelect.ItemsEmpty, { children: "No results" }, void 0))] }, void 0)] }, void 0));
};
const Item = ({ post, active }) => {
    var _a, _b, _c;
    const authorName = ((_b = (_a = post.createdBy) === null || _a === void 0 ? void 0 : _a.member) === null || _b === void 0 ? void 0 : _b.name) || 'Unknown';
    const time = dayjs(post.createdAt).fromNow();
    const spaceName = ((_c = post.space) === null || _c === void 0 ? void 0 : _c.name) || 'Untitled';
    return (_jsxs(Media, { icon: _jsx(SpaceImage, { size: "sm", space: post.space }, void 0), align: "center", children: [_jsx("div", { className: clsx('truncate', active ? 'text-content-on-primary' : 'text-content'), children: post.title }, void 0), _jsxs("div", { className: clsx('truncate', active ? 'text-content-on-primary' : 'text-content-subdued'), children: ["Posted on", ' ', _jsx("span", { className: clsx(active ? 'text-content-on-primary' : 'text-content'), children: spaceName }, void 0), ' ', time, " by", ' ', _jsx("span", { className: clsx(active ? 'text-content-on-primary' : 'text-content'), children: authorName }, void 0)] }, void 0)] }, void 0));
};
//# sourceMappingURL=PostPicker.js.map